import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export const getPay = createAsyncThunk(
  'UserInfoCollection/getPay',
  async (p: any, store: any) => {
    const resp = await http.post('/live/pay/get_pay_info', {
      ...store.getState().env.deviceinfo,
      ...store.getState().env.otherInfo,
      ...p,
    })
    return resp.data
  }
)

export const updatePay = createAsyncThunk(
  'UserInfoCollection/updatePay',
  async (p: any, store: any) => {
    const resp = await http.post('/live/pay/update_pay_info', {
      ...store.getState().env.deviceinfo,
      ...store.getState().env.otherInfo,
      ...p,
    })
    return resp.data
  }
)

export enum FIELD_NAME {
  name = 'name',
  email = 'email',
  document = 'document',
  state = 'state',
  city = 'city',
  zip_code = 'zip_code',
  street = 'street',
  number = 'number',
  phone = 'phone',
}

const initialState: {
  pay: any
  fields: Array<FIELD_NAME>
} = {
  pay: {},
  fields: [],
}

export const UserInfoCollectionSlice = createSlice({
  name: 'UserInfoCollection',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPay.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, data)
    })
  },
})

export default UserInfoCollectionSlice.reducer
